import axios from 'axios';
import { getEncryptedLocalStorageItem, removeLoginEncryptedLocalStorage } from './localStorage';
import { showToastError } from './toastUtils';

// const apiUrl = 'http://localhost:9600/hmi';
// const apiUrl = process.env.REACT_APP_BASE_URL || 'https://agua.one/eh-api/hmi';
const apiUrl = 'https://aio.api.agua.one/hmi';


// const apiUrl = 'http://agua.centralindia.cloudapp.azure.com/eh-api/hmi';

// Function to make a GET request
export const getData = async (subPath) => {
    try {
        // if (!authToken)
        //     updateAuthorization(getEncryptedLocalStorageItem('token'));

        const authToken = getEncryptedLocalStorageItem('token');
        const axiosInstance = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        const response = await axiosInstance.get(subPath);
        return response.data;
    } catch (error) {
        showToastError(error.response.data.message || error.response.data.msg);
        if (error.response && error.response.status === 401)
            removeLoginEncryptedLocalStorage();
        return {
            status: false,
            code: error.response && error.response.status
        };
    }
};

// Function to make a POST request
export const postData = async (path = '', newItem) => {
    try {
        // if (!authToken)
        //     updateAuthorization(getEncryptedLocalStorageItem('token'));
        const authToken = getEncryptedLocalStorageItem('token');
        const axiosInstance = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        const response = await axiosInstance.post(path, newItem);
        return response.data;
    } catch (error) {
        showToastError(error.response.data.message || error.response.data.msg);
        if (error.response && error.response.status === 401)
            removeLoginEncryptedLocalStorage();
        return {
            status: false,
            code: error.response && error.response.status
        };
    }
};

// Function to make a PATCH request
export const updateData = async (subPath = '/', updatedItem) => {
    try {
        // if (!authToken)
        //     updateAuthorization(getEncryptedLocalStorageItem('token'));
        const authToken = getEncryptedLocalStorageItem('token');
        const axiosInstance = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        const response = await axiosInstance.patch(subPath, updatedItem);
        return response.data;
    } catch (error) {
        showToastError(error.response.data.message || error.response.data.msg);
        if (error.response && error.response.status === 401)
            removeLoginEncryptedLocalStorage();
        return {
            status: false,
            code: error.response && error.response.status
        };
    }
};


// Function to make a PATCH request
export const updateFileData = async (subPath = '/', updatedItem) => {
    try {
        const authToken = getEncryptedLocalStorageItem('token');
        const response = await axios.patch(`${apiUrl}${subPath}`, updatedItem, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'multipart/form-data',
            },
        });


        return response.data;
    } catch (error) {
        showToastError(error.response.data.message || error.response.data.msg);
        if (error.response && error.response.status === 401)
            removeLoginEncryptedLocalStorage();
        return {
            status: false,
            code: error.response && error.response.status
        };
    }
};


// Function to make a DELETE request
export const deleteData = async (subPath = '/') => {
    try {
        // if (!authToken)
        //     updateAuthorization(getEncryptedLocalStorageItem('token'));

        const authToken = getEncryptedLocalStorageItem('token');
        const axiosInstance = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        const response = await axiosInstance.delete(subPath);
        return response.data;
    } catch (error) {
        showToastError(error.response.data.message || error.response.data.msg);
        if (error.response && error.response.status === 401)
            removeLoginEncryptedLocalStorage();
        return {
            status: false,
            code: error.response && error.response.status
        };
    }
};

